import base from "../../libs/axios";

export const createImportHours = (data) =>
  base
    .post(`/api/activity-logs/import?propertyType=${data.propertyType}`, data)
    .then(({ data }) => data)
    .catch((err) => {
      throw err;
    });
